<template>
    <div>
        <div class="searchs">
            <el-input placeholder="请输入书名查找" v-model="lookName" class="input-with-select">

                <el-button slot="append" icon="el-icon-search" @click="onLook"></el-button>
            </el-input>
        </div>
        <div class="looks">
            <div class="typeSearch">
                <span>按类型查找： </span>
                <el-select v-model="typeValue" placeholder="请选择" @change="changeType">
                    <el-option label="全部书籍" value="0">
                    </el-option>
                    <el-option label="智慧交通" value="1">
                    </el-option>
                    <el-option label="企业内刊" value="2">
                    </el-option>
                </el-select>
            </div>
            <div class="covers">
                <img src="https://www.dpark.com.cn/ycxxFileUrl/looks/SIPSGBrochure/SIPSG-cover.jpg" alt="">
                <img src="https://www.dpark.com.cn/ycxxFileUrl/looks/bookshelf1.png" alt="">
                <!-- <div class="lookName">
                    <span>SIPSG</span>
                </div> -->
            </div>
            <div class="lookLists">
                <div class="item" v-for="(item, index) in showList" @click="onLookPdf(item)">
                    <div class="coversLook">
                        <img :src="item.imgUrl" alt="">
                        <div class="lookName">
                            <span>{{ item.name }}</span>
                        </div>
                    </div>
                    <img class="listBack" v-if="index % 3 === 0"
                        src="https://www.dpark.com.cn/ycxxFileUrl/looks/bookshelf2.png" alt="">
                </div>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        // 1:智慧交通2：企业内刊
        return {
            lookName: '',
            select: '',
            typeValue: "",
            lookList: [
                {
                    name: '智慧交通整体解决方案',
                    imgUrl: 'https://www.dpark.com.cn/ycxxFileUrl/looks/Transportation/Transportation-cover.jpg',
                    url: 'https://www.dpark.com.cn/ycxxFileUrl/looks/Transportation/Transportation-Full.pdf',
                    type: '1'
                },
                {
                    name: '园测信息2023第三季度内刊',
                    imgUrl: 'https://www.dpark.com.cn/ycxxFileUrl/looks/SIPSGInternal/SIPSGInternal-cover.jpg',
                    url: 'https://www.dpark.com.cn/ycxxFileUrl/looks/SIPSGInternal/SIPSGInternal-Full.pdf',
                    type: '2'
                }

            ],
            showList: []
        }

    }, mounted() {
        this.showList = this.lookList;
    }, methods: {
        onLook() {
            this.showList = [];
            this.lookList.forEach(e => {
                if (e.name.indexOf(this.lookName) > -1) {
                    this.showList.push(e);
                }
            })
        },
        changeType() {
            this.showList = [];
            this.lookList.forEach(e => {
                if (this.typeValue == '0') {
                    this.showList.push(e);
                } else if (e.type == this.typeValue) {
                    this.showList.push(e);
                }
            })
        },
        onLookPdf(data) {          
            this.$router.push({ path: '/seePdf', query: { name:data.url} });
         

        }
    }
}
</script>
<style lang="scss" scoped>
.searchs {
    height: 90px;
    background: linear-gradient(#3274FF, #67a2f9);
    display: flex;
    align-items: center;
    padding: 0 30px;

    ::v-deep .el-input-group {
        border-radius: 45px;
        overflow: hidden;
    }

    ::v-deep .el-input__inner {
        height: 60px;
        border: none;
        font-size: 24px;
        padding-left: 30px;
    }

    ::v-deep .el-button {
        width: 100px;
        background-color: #fff;
    }

    ::v-deep .el-icon-search {
        font-size: 28px;
        color: #3274FF;

    }
}

.el-select-dropdown__item {
    font-size: 24px !important;
    height: 30PX;
    line-height: 30PX;
    color: #666;
}

.looks {
    width: 100%;
    height: calc(100vh - 90px);
    background-image: url('https://www.dpark.com.cn/ycxxFileUrl/looks/back.png');
    background-size: 100%;
    position: relative;

    .typeSearch {
        position: absolute;
        top: 40px;
        right: 40px;
        display: flex;
        align-items: center;
        font-size: 24px;
        color: #333;
        z-index: 99;

        ::v-deep .el-input__inner {
            border: none;
            font-size: 24px !important;
            width: 220px;
            color: #666 !important;
        }

    }

    .covers {
        text-align: center;
        display: flex;
        justify-content: center;
        position: relative;
        padding-top: 160px;

        img {
            &:first-child {
                width: 225px;
                position: relative;
                z-index: 2;
            }

            &:last-child {
                width: 513px;
                height: 70px;
                position: absolute;
                bottom: -50px;
            }
        }
    }

    .lookLists {
        display: grid;
        grid-template-columns: repeat(3, 28%);
        grid-row-gap: 90px;
        grid-column-gap: 7%;
        align-items: end;
        padding: 0 60px;
        margin-top: 150px;

        .item {
            position: relative;

            .coversLook {
                width: 100%;
                min-height: 100px;
                position: relative;

                .lookName {
                    background: rgba($color: #000000, $alpha: 0.7);
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    font-size: 20px;
                    padding: 5px 6px;
                    box-sizing: border-box;
                    color: #fff;
                    text-align: center;
                }

                img {
                    width: 100%;
                }

            }

            .listBack {
                position: absolute;
                width: 712px;
                height: 111px;
                bottom: -110px;
                z-index: 3;
                left: -40px;
            }
        }
    }
}
</style>